(function (checks, $) {
    checks.dataTableLocalStorageFilterInfoKey = 'DataTables_' + $('#wageComponentsGrid').attr('id') + '_FilterInfo';
    checks.selectedCategoryType = undefined;
    checks.InitCategoryType = function () {
        $('#CheckCategoryViewModel_Type_None,#ChecklistItemViewModel_Type_None,#MonthlyChecklistViewModel_Type_None').parent().hide();

        if ($('#MonthlyChecklistViewModel_Type_None').length) {
            checks.initMonthlyChecklistProperties();
        }
    }

    checks.InitCategoryTypeChangeHandlers = function () {
        $(document).on("change", "[data-monthly-checklist-category-type]", function (evt) {
            checks.initMonthlyChecklistProperties();
        });
    }

    checks.InitCategoryApplicationChangeHandlers = function () {
        $(document).on("change", "[data-category-application]", function (evt) {
            switch ($("[data-category-application] :checked").val()) {
                default:
                case "Isae":
                    $('[data-category-type]').hide();
                    $("#CheckCategoryViewModel_Type_None").prop('checked', true);
                    checks.selectedCategoryType = undefined;
                    break;
                case "Checklist":
                case "Both":
                    $('[data-category-type]').show();
                    if (!checks.selectedCategoryType)
                        $("#CheckCategoryViewModel_Type_Month").prop('checked', true);
                    break;
            }

            $(document).on("change", "[data-category-type]", function (evt) {
                checks.selectedCategoryType = $(evt.target);
            });
        });
    }

    checks.initMonthlyChecklistProperties = function () {
        switch ($("[data-monthly-checklist-category-type] :checked").val()) {
            case "Month":
                $('[data-checklist-month]').parent().show();
                $("[data-checklist-year], [data-checklist-month]").trigger("change");
                break;
            default:
            case "Startup":
                $('[data-checklist-month]').parent().hide();
                $('[data-checklist-month]').prop('value', 1);
                $('#messageCorrectionList').removeClass('d-block').addClass('d-none');
                break;
            case "Closure":
                $('[data-checklist-month]').parent().hide();
                $('[data-checklist-month]').prop('value', 12);
                $('#messageCorrectionList').removeClass('d-block').addClass('d-none');
        }
    }

    checks.InvokeChecklistMonthChangeHandler = function () {
        $("[data-checklist-month]").change();
    }

    checks.InitChecklistHandlers = function () {
        $(document).on("click", "[data-checklist-submit]", function (evt) {
            $.ajax({
                url: "/Checks/Checklists/ChecklistOverview",
                cache: false,
                data: {
                    key: $('#completeChecklist > [data-checklist-key]').val(),
                    employerKey: $('#completeChecklist > [data-checklist-employerKey]').val(),
                    remarks: $('[data-checklist-remarks]').val(),
                },

                success: function (context) {
                    if (context.controller != null && context.controllerAction != null) {
                        window.location.replace(`/${context.area}/${context.controller}/${context.controllerAction}/?employerKey=${context.employerKey}`)
                    }
                }
            });
        });
    }

    /* Initialize handlers for checklist creation */
    checks.InitCreateChecklistHandlers = function () {
        $(document).on("change", "[data-checklist-year], [data-checklist-month]", function (evt) {
            if ($("[data-monthly-checklist-category-type] :checked").val() === 'Month') {
                $.ajax({
                    url: "/Checks/Checklists/MaxSequenceNumberOfMonthlyChecklist",
                    cache: false,
                    data: {
                        employerKey: $('[data-checklist-employerkey]').val(),
                        year: $('[data-checklist-year]').val(),
                        month: $('[data-checklist-month]').val()
                    },

                    success: function (data) {
                        if (data.maxSequenceNumber >= 0)
                            $('#messageCorrectionList').removeClass('d-none').addClass('d-block');
                        else
                            $('#messageCorrectionList').removeClass('d-block').addClass('d-none');
                    }
                });
            }
        });
    }

    /* Initialize handlers for checklist overview */
    checks.InitChecklistOverviewHandlers = function () {
        $(document).on("change", "[data-team]", function (evt) {
            $("#clientSelectionViewPartial").empty();
            var teamCode = $(this).val();
            if (teamCode) {
                $("#clientSelectionViewPartial").load("/Checks/Checklists/DisplayClientsForTeam?teamAfasCode=" + globalCore.urlEncode(teamCode), function () {
                    var form = $("form#searchform");
                    $.removeData(form[0], 'validator');
                    $.validator.unobtrusive.parse(form);

                    // when client is already chosen, do an immediate search
                    if ($("#Client").val() !== "") {
                        form.submit();
                    }
                });
            }
        });
        $("[data-team]").change();
    }

    /* Initialize handlers for payments overview */
    checks.InitPaymentHandlers = function () {
        $(document).on("change", "[data-team]", function (evt) {
            $("#clientSelectionViewPartial").empty();
            var teamCode = $(this).val();
            if (teamCode) {
                $("#clientSelectionViewPartial").load("/Checks/Payments/DisplayClientsForTeam?teamAfasCode=" + globalCore.urlEncode(teamCode), function () {
                    var form = $("form#searchform");
                    $.removeData(form[0], 'validator');
                    $.validator.unobtrusive.parse(form);
                });
            }
        });
        $("[data-team]").change();
    }

    /* Initialize handlers for workflow overview */
    checks.InitWorkflowHandlers = function () {
        $(document).on("change", "[data-team]", function (evt) {
            const teamCode = $(this).val();
            // If there is a team code, load the teams related to the team code, else clear the selection
            if(teamCode)
                $("#clientSelectionViewPartial").load("/Checks/Workflows/DisplayClientsForTeam?teamAfasCode=" + globalCore.urlEncode(teamCode));
            else {
                $("#clientSelectionViewPartial").empty();
            }
        });
        // Trigger a change so the customer partial view can be set
        $("[data-team]").trigger("change");

        selectAllCustomers = function () {
            $("form[action='/Checks/Workflows/Search'] input[type='checkbox'][id*='Clients']").prop('checked', true);
        };

        deselectAllCustomers = function () {
            $("form[action='/Checks/Workflows/Search'] input[type='checkbox'][id*='Clients']").prop('checked', false);
        };
    }

    /* Initialize the wage component search and synchronize buttons to trigger the correct form action on click */
    checks.InitWageComponentButtons = function () {
        $('#searchSubmit').click(function () {
            let team = $('#Team').find(":selected").val();
            let filterOwnComponents = $('#FilterOwnComponents').is(':checked');
            // Save the filter info to local storage
            let filterInfo = {
                TeamId: team,
                FilterOwnComponents: filterOwnComponents,
                ValidUntil : Date.now() + (2 * 60 * 60 * 1000) // 2 hours, same as default for datatables
            }
            var jsonFilterInfo = JSON.stringify(filterInfo);
            localStorage.setItem(checks.dataTableLocalStorageFilterInfoKey, jsonFilterInfo);
            checks.reloadTable(team, filterOwnComponents);
        });

        let submit = $('#synchronizeSubmit');
        submit.click(function () {
            $('#wageComponentForm').validate();
            if ($('#wageComponentForm').valid()) {
                let team = $('#Team').find(":selected").val();
                globalCore.OnSubmitBegin(submit);
                $.ajax({
                    type: "POST",
                    url: "/Checks/WageComponents/Synchronize?teamAfasCode=" + team,
                    cache: false,
                    success: function (data) {
                        if (data.success === true) {
                            checks.InitWageComponentsGrid();
                        }
                    },
                    complete: function () { globalCore.OnSubmitComplete(submit) }
                });
            } else {
                return false;
            }
        });
    }

    checks.OnProgressStatusChanged = function () {
        $.ajax({
            type: "POST",
            url: "/Checks/WageComponents/UpdateProgressStatus",
            cache: false,
            data: {
                wageComponentKey: $('#Key').val(),
                subscriptionKey: $('#SubscriptionKey').val(),
                progressStatus: $('#ProgressStatus').val()
            },
            success: function (result) {
                globalCore.ShowAlert(result.success, "#sync-alert-container-wagecomponent", "De voortgang status is opgeslagen.", "Het opslaan van de voortgang status is mislukt.");
            }
        });
    }

    checks.UpdateWageComponentRemarks = function () {
        $.ajax({
            type: "POST",
            url: "/Checks/WageComponents/UpdateRemarks",
            cache: false,
            data: {
                wageComponentKey: $('#Key').val(),
                subscriptionKey: $('#SubscriptionKey').val(),
                remarks: $('#Remarks').val()
            },
            success: function (result) {
                globalCore.ShowAlert(result.success, "#sync-alert-container-wagecomponent", "De opmerking is opgeslagen.", "Het opslaan van de opmerking is mislukt.");
            }
        });
    }

    checks.UpdateCheckListRemarks = function () {
        $.ajax({
            type: "POST",
            url: "/Checks/Checklists/UpdateRemarks",
            cache: false,
            data: {
                key: $('#completeChecklist > [data-checklist-key]').val(),
                employerKey: $('#completeChecklist > [data-checklist-employerKey]').val(),
                remarks: $('[data-checklist-remarks]').val(),
            },
            success: function (result) {
                globalCore.ShowAlert(result.success, "#sync-alert-container-checklist", "De opmerking is opgeslagen.", "Het opslaan van de opmerking is mislukt.");
            }
        });
    }

    checks.InitWageComponentsGrid = function () {
        //Get the saved filter info from local storage and apply it
        let retrievedJsonFilterInfo = localStorage.getItem(checks.dataTableLocalStorageFilterInfoKey);
        let teamAfasCode;
        let filterOwnComponents;

        if (retrievedJsonFilterInfo) {
            let retrievedFilterInfo = JSON.parse(retrievedJsonFilterInfo);
            // Apply previous filters if they're still valid
            if (retrievedFilterInfo.ValidUntil >= Date.now()) {
                teamAfasCode = retrievedFilterInfo.TeamId;
                filterOwnComponents = retrievedFilterInfo.FilterOwnComponents;
                retrievedFilterInfo.ValidUntil = Date.now() + (2 * 60 * 60 * 1000) // 2 hours, same as default for datatables

                // Update UI for filters
                $('#Team').val(teamAfasCode).trigger('change');
                $('#FilterOwnComponents').prop('checked', filterOwnComponents).trigger('change');
            }
        }

        checks.dataTable = $('#wageComponentsGrid').DataTable(datatable.defaultDataTableOptions({
            lengthMenu: [10, 25, 50, 100],
            ajax: {
                url: '/Checks/WageComponents/SearchWageComponents?teamAfasCode=' + globalCore.urlEncode(teamAfasCode) + '&filterOwnComponents=' + filterOwnComponents
            },
            columns: [
                { data: "clientName", defaultContent: "", name: "ClientName", title: "Klantnaam", orderable: true, searchable: true },
                { data: "caoDescription", defaultContent: "", name: "CaoDescription", title: "Cao", orderable: true, searchable: true },
                { data: "number", defaultContent: "", name: "Number", title: "Nummer", orderable: true, searchable: true },
                { data: "description", defaultContent: "", name: "Description", title: "Omschrijving", orderable: true, searchable: true },
                { data: "changedBy", defaultContent: "", name: "ChangedBy", title: "Laatst gewijzigd door ", orderable: true, searchable: true },
                { data: "changedDate", defaultContent: "", name: "ChangedDate", title: "Laatst gewijzigd op", orderable: true, searchable: false },
                { data: "status", defaultContent: "", name: "Status", title: "Status", enum: enums.wageComponentStatus, multiselect: true, orderable: true, searchable: true },
                { data: "progressStatus", defaultContent: "", name: "ProgressStatus", title: "Voortgang", enum: enums.wageComponentProgressStatus, multiselect: true, orderable: true, searchable: true },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            searchCols: [
                null,
                null,
                null,
                null,
                null,
                null,
                { search: '0;1' },
                null,
                null
            ],
            columnDefs: [
                {
                    targets: 0,
                    width: '10%',
                    className: 'text-truncate'
                },
                {
                    targets: 1,
                    width: '10%',
                    className: 'text-truncate'
                },
                {
                    targets: 2,
                    width: '50px',
                    className: 'text-truncate'
                },
                {
                    targets: 3,
                    className: 'text-truncate'
                },
                {
                    targets: 4,
                    width: '10%',
                    className: 'text-truncate'
                },
                {
                    targets: 5,
                    width: '100px',
                    className: 'text-truncate, text-center',
                    render: function (data, type, full, meta) {
                        return datatable.dutchDateFormat(data, "DD-MM-YYYY HH:mm")
                    }
                },
                {
                    targets: [6, 7],
                    width: '10%',
                    className: 'text-center'
                },
                {
                    targets: -1,
                    width: '100px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `<a class="btn btn-datatable btn-outline-primary fas fa-external-link-alt" title="Wijzigen" href="/Checks/WageComponents/Details?subscriptionKey=${globalCore.urlEncode(full.subscriptionKey)}&wageComponentKey=${globalCore.urlEncode(full.key)}&team=${globalCore.urlEncode(teamAfasCode)}"></a>`;
                    }
                }
            ]
        }));
    }

    checks.reloadTable = function (teamAfasCode, filterOwnComponents) {
        if (!checks.dataTable) {
            checks.InitWageComponentsGrid();
            return;
        }
        checks.dataTable.ajax.url('/Checks/WageComponents/SearchWageComponents?teamAfasCode=' + globalCore.urlEncode(teamAfasCode) + '&filterOwnComponents=' + filterOwnComponents).load();
    }

}(window.checks = window.checks || {}, $));
